import { FeedItem } from '@knocklabs/client';
import { useKnockFeed } from '@knocklabs/react-notification-feed';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import Avatar from 'src/shared-components/Avatar';

const DEFAULT_USER_AVATAR = process.env.DEFAULT_USER_AVATAR || '';

const NotificationItem = ({ notification }: { notification: FeedItem }) => {
  const isActor = notification?.actors[0];
  const knockFeed = useKnockFeed();

  useEffect(() => {
    return () => {
      if (!notification.seen_at) {
        knockFeed?.feedClient.markAsSeen(notification);
        knockFeed?.feedClient.markAsRead(notification);
      }
    };
  }, []);

  return (
    <li key={notification.id} className="py-6 pl-6 flex mb-5 rounded-xl shadow bg-white">
      <div className="mr-5 relative">
        {!notification.seen_at && (
          <div className="absolute bg-[#C1259F] rounded-full z-10 flex justify-center items-center text-center w-4 h-4 -top-[5px] left-3/4 border-2 border-white" />
        )}
        <Avatar
          size={'xs'}
          roundness={'md'}
          image={
            isActor
              ? notification?.actors[0].avatar
                ? notification?.actors[0].avatar
                : DEFAULT_USER_AVATAR
              : '/images/logo-dark.png'
          }
        />
      </div>
      <div>
        <div
          className="text-xl font-medium text-black"
          dangerouslySetInnerHTML={{ __html: notification?.blocks[0].rendered }}
        />
        <div className="text-md text-gray-500 font-medium">
          {DateTime.fromISO(notification.inserted_at).toRelative()}
        </div>
      </div>
    </li>
  );
};

export default NotificationItem;
